import React from 'react'
import PropTypes from 'prop-types'
import Icon from '@/components/Icon'
import { Button as RsButton } from 'reactstrap'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import classnames from 'classnames/dedupe'
import Tooltip from '@/components/Tooltip'
import uuid from 'uuid'

class Button extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.any,
    icon: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    confirmText: PropTypes.string,
    confirmTitle: PropTypes.string,
    iconOnly: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipPlacement: PropTypes.string
  }

  constructor (props) {
    super(props)
    this._id = 'btn_' + uuid()
  }

  onClick = e => {
    e.preventDefault()
    const { confirmText, confirmTitle, onClick } = this.props
    if (confirmText) {
      getStore().dispatch(dialogActions.openDialog({
        dialogType: dialogTypes.confirm,
        title: confirmTitle,
        content: confirmText,
        onAction: () => onClick(e)
      }))
    } else {
      onClick(e)
    }
  }

  render () {
    const { children, icon, confirmText, confirmTitle, className, iconOnly, tooltip, tooltipPlacement, ...otherProps } = this.props
    const id = this.props.id || this._id
    const renderButton = () => (
      <RsButton {...otherProps} id={id} className={classnames(className, { 'btn-icon': iconOnly }, { 'disabled': otherProps.disabled })}
        onClick={this.onClick}>
        {icon ? (
          <React.Fragment>
            <Icon name={icon} /><span>{children && <span>{children}</span>}</span>
          </React.Fragment>
        ) : (children)}
      </RsButton>
    )
    if (tooltip && !otherProps.disabled) {
      return (
        <React.Fragment>
          {renderButton()}
          <Tooltip target={id} placement={tooltipPlacement || 'top'}>
            {tooltip}
          </Tooltip>
        </React.Fragment>
      )
    }
    return renderButton()
  }
}

export {
  Button
}



// WEBPACK FOOTER //
// ./src/components/button.js